import { Modal, Table } from "antd";
import { memo } from "react";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const columns = [
  {
    title: "Sr. No.",
    dataIndex: "srNo",
    key: "srNo",
    render: (text, data, index) => index + 1,
  },
  {
    title: "Day of Embryos",
    dataIndex: "embryos_days",
    key: "embryos_days",
  },
  {
    title: "ID of Embryos",
    dataIndex: "embryos_id",
    key: "embryos_id",
  },
  {
    title: "Score of Embryos",
    dataIndex: "embryos_score",
    key: "embryos_score",
  },
  {
    title: "Color of Goblet",
    dataIndex: "goblet_color",
    key: "goblet_color",
  },
  {
    title: "Color of Device",
    dataIndex: "device_color",
    key: "device_color",
  },
  {
    title: "Tank No.",
    dataIndex: "tank_no",
    key: "tank_no",
  },
  {
    title: "Canister No.",
    dataIndex: "canister_no",
    key: "canister_no",
  },
  {
    title: "PGS Report",
    dataIndex: "pgs_report",
    key: "pgs_report",
  },
  {
    title: "Transfer Recomm.",
    dataIndex: "transfer_recommendations",
    key: "transfer_recommendations",
  },
];

const PGTDischargeCardModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="PGT Discharge Card Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        {" "}
        <div className="modal-details">
          <div className="modal-content-details">
            {/* <div className='col-lg-6'> */}
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>IVF ID</div>
                <div>{activePatientJourneyModuleDetails?.ivf_flow_id}</div>
                <div>Valid up to</div>
                <div>
                  {activePatientJourneyModuleDetails?.valid_upto
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.valid_upto
                      )
                    : ""}
                </div>
                <div>Date of Pickup</div>
                <div>
                  {activePatientJourneyModuleDetails?.pick_up_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.pick_up_date
                      )
                    : ""}
                </div>
                <div>Date of PGS</div>
                <div>
                  {activePatientJourneyModuleDetails?.pgs_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.pgs_date
                      )
                    : ""}
                </div>
                <div>Vitrification Date</div>
                <div>
                  {activePatientJourneyModuleDetails?.vitrification_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.vitrification_date
                      )
                    : ""}
                </div>
                <div>Renewal Date</div>
                <div>
                  {activePatientJourneyModuleDetails?.renewal_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.renewal_date
                      )
                    : ""}
                </div>
              </div>
            </div>

            {/*  </div>
      <div className='col-lg-6'>
           
          </div> */}
            {/* <div className="details">
            <div className="table-title">
              Other Details
            </div>
            <div className="details-table">
              <div>Day of Embryos</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>ID of Embryos</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Score of Embryos</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Color of Goblet</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Color of Device</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Tank No.</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Canister No.</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>PGS Report</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
              <div>Transfer Recommendations</div>
              <div>{activePatientJourneyModuleDetails?.embryos_days}</div>
            </div>
          </div> */}

            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>Embryo Biopsy By</div>
                <div>{activePatientJourneyModuleDetails?.embryo_biopsy_by}</div>
                <div>Vitrification Done By</div>
                <div>
                  {activePatientJourneyModuleDetails?.vetrification_done_by}
                </div>
                <div>Assisted By</div>
                <div>{activePatientJourneyModuleDetails?.assisted_by}</div>
                <div>Media Used</div>
                <div>{activePatientJourneyModuleDetails?.freezing_media}</div>
                <div>Device Used</div>
                <div>
                  {activePatientJourneyModuleDetails?.vitrification_devices}
                </div>
                <div>Expiry Date of Media</div>
                <div>
                  {activePatientJourneyModuleDetails?.expiry_date_media
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.expiry_date_media
                      )
                    : ""}
                </div>
                <div>Batch No. of Media</div>
                <div>{activePatientJourneyModuleDetails?.batch_no_media}</div>
                <div>PGS Lab Details</div>
                <div>{activePatientJourneyModuleDetails?.pgs_lab_details}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <div className="table-title">Other Details</div>

            <Table
              columns={columns}
              dataSource={
                activePatientJourneyModuleDetails?.pgs_discharge_card_table
              }
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(PGTDischargeCardModal);
